import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import FacetedSearch from '../Components/FacetedSearch';
import { query, searchFacetChange, clearFilterApplied } from '../Actions/FacetedSearch.action';

class FacetedSearchContainer extends Component {
    render() {
        return (<Fragment><FacetedSearch {...this.props} /></Fragment>);
    }
}
const mapStateToProps = ({ facetedSearch: { facetFilters, navigationTheme, loading } }) => {
    return { facetFilters, navigationTheme, loading }
}

const mapDispatchToProps = dispatch => {
    return {
        query: (q, replaceResult) => dispatch(query(q, replaceResult)),
        searchFacetChange: (group, item) => dispatch(searchFacetChange(group, item)),
        clearFilterApplied: () => dispatch(clearFilterApplied())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FacetedSearchContainer);